<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>1. Thành tích thi</h1>
                </div>
                <div><img src="/static\images\vi\newManual\achievementManual-1.png" alt="" /></div>
                <div>
                    <p>① Sau khi hoàn thành Bài thi cuối kỳ hoặc Bài thi giữa kỳ, nhấn vào biểu tượng [Thành tích], thì màn hình Thành tích thi cuối kỳ sẽ được hiển thị。</p>
                </div>
                <div><img src="/static\images\vi\newManual\achievementManual-2.png" alt="" /></div>
                <div>
                    <p>② Có thể tham chiếu thành tích của Bài thi cuối kỳ hoặc Bài thi giữa kỳ.</p>
                    <p>※ Bạn có thể xem thêm cách kiểm tra lịch sử thi ở mục [Lịch sử dự thi].</p>
                </div>
                <div>
                    <h1>2. Lịch sử thi</h1>
                </div>
                <div><img src="/static\images\vi\newManual\historyExamManual-1.png" alt="" /></div>
                <div>
                    <p>① Khi nhấn nút [Xem lịch sử dự thi], thì sẽ di chuyển đến màn hình Lịch sử tham gia kì thi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\historyExamManual-2.png" alt="" /></div>
                <div>
                    <p>② Khi nhấn nút [Quay lại], thì sẽ quay về màn hình tình Thành tích thi.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>1. Thành tích thi</h1>
                </div>
                <div><p>① Sau khi hoàn thành Bài thi cuối kỳ hoặc bài thi giữa kì, nhấn vào biểu tượng [Thành tích], thì màn hình Thành tích thi sẽ được hiển thị.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\score_static_1.png" alt="" /></div>
                <div><p>② Có thể tham chiếu thành tích của thi của bạn [Tên kì thi], [Điểm thi cao nhất], [Kết quả], [Điểm tối đa], [Điểm chuẩn], [Biểu đồ thi].</p></div>
                <div><p>● Tên kì thi: Hiển thị tên kì thi bạn đã làm.</p></div>
                <div><p>● Điểm thi cao nhất: Điểm cao nhất bạn đạt trong bài thi.</p></div>
                <div><p>● Kết quả: Kết quả của bạn Đậu hay Không đậu trog kì thi.</p></div>
                <div><p>● Điểm tối đa: Điểm tối đa của bài thi.</p></div>
                <div><p>● Điểm chuẩn: Điểm chuẩn bạn phải vượt qua trong bài thi.</p></div>
                <div><p>● Biểu đồ thi: bạ sẽ so sánh được điểm hiện tại của bạn với điểm thi cao nhất, điểm thi thấp nhất và điểm thi trung bình của khóa học đó.</p></div>
                <div><p>※ Bạn có thể xem thêm cách kiểm tra lịch sử thi ở mục [Lịch sử dự thi].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\score_static_2.png" alt="" /></div>
                <div>
                    <h1>2. Lịch sử thi</h1>
                </div>
                <div><p>① Sau khi hoàn thành Bài thi cuối kỳ, nhấn vào biểu tượng [Thành tich], thì màn hình Thành tích thi cuối kỳ sẽ được hiển thị. Trong này sẽ có nút [Xem lịch sử dự thi].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\history_score_static_1.png" alt="" /></div>
                <div><p>② Khi nhấn nút [Xem lịch sử dự thi], thì sẽ di chuyển đến màn hình Lịch sử tham gia kì thi cuối kỳ.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\history_score_static_2.png" alt="" /></div>
                <div><p>③ Nhấn vào dấu mũi tên để hiển thị thông tin chi tiết cho từng khóa học.</p></div>
                <div><p>● Thời gian làm bài thi: Thời gian bạn làm được trong bài thi.</p></div>
                <div><p>● Thời gian bắt đầu thi: Thời gian bạn bắt đầu vào thi.</p></div>
                <div><p>● Thời gian kết thúc thi: Thời gian bạn nộp bài thi.</p></div>
                <div><p>● Điểm tối đa: Điểm tối đa của một bài thi.</p></div>
                <div><p>● Điểm chuẩn: Điểm bạn phải vượt qua được bài thi.</p></div>
                <div><p>● Điểm đạt được: Điểm bạn đạt được trong bài thi.</p></div>
                <div><p>● Đánh giá: Dựa vào điểm đạt được của bạn so với điểm chuẩn để đánh giá bạn đậu hay không đậu.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\history_score_static_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/achievement_manual.vue